import React from 'react'
import { connect } from 'react-redux'
import CouponProviderActions from '../../Redux/CouponProviderRedux'

class DeleteProvider extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  _delete = (event) => {
    event.preventDefault()
    let id = this.props.detail.id
    this.props.deleteCouponProvider(id)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <section className='section' style={{ width: '30vw' }}>
        <div className='title-block'>
          <h3 className='title'>Delete Provider</h3>
        </div>
        <div className='mt-2'>
          <p>Confirm deletion for:</p>
          <p className='text-center'>Provider Name: {this.props.detail.name}</p>
        </div>
        <form onSubmit={(event) => this._delete(event)}>
          <div className='row'>
            <div className='col-12 text-right'>
              <button className='btn btn-secondary mr-2' type='button' onClick={() => this.props.closeModal()}>Cancel</button>
              <button className='btn btn-danger' type='submit'>Delete</button>
            </div>
          </div>
        </form>
      </section>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  deleteCouponProvider: (id) => dispatch(CouponProviderActions.deleteCouponProviderRequest(id))
})

export default connect(stateToProps, dispatchToProps)(DeleteProvider)



// WEBPACK FOOTER //
// ./src/Containers/Coupon/DeleteProvider.js